import apiClient from "./api";

export interface Coupon {
  id?: number;
  code: string;
  name: string;
  type: string;
  discount: number;
  start_date: string;
  end_date: string;
  limit: number;
  status: number;
  product_for_cus?: number;
  product_id?: number;
  service_id?: number;
  description?: string;
}
const couponService = {
  async verify(code: string, amount?: number) {
    const response = await apiClient.post("/coupons/verify", { code, amount });
    return response.data;
  },

  async getCoupons() {
    const response = await apiClient.get("/coupons");
    return response.data;
  },

  async getCoupon(id: number) {
    const response = await apiClient.get(`/coupons/${id}`);
    return response.data;
  },

  async createCoupon(coupon: Coupon) {
    const response = await apiClient.post("/coupons", coupon);
    return response.data;
  },

  async updateCoupon(id: number, coupon: Coupon) {
    const response = await apiClient.put(`/coupons/${id}`, coupon);
    return response.data;
  },

  async deleteCoupon(id: number) {
    const response = await apiClient.delete(`/coupons/${id}`);
    return response.data;
  }
};

export default couponService;
